import React from "react";

export const LaptopIcon = (): JSX.Element => {
    return (
        <svg width="26" height="17" viewBox="0 0 26 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M20.25 0.75H5.25C4.42157 0.75 3.75 1.42157 3.75 2.25V10.25C3.75 11.0784 4.42157 11.75 5.25 11.75H20.25C21.0784 11.75 21.75 11.0784 21.75 10.25V2.25C21.75 1.42157 21.0784 0.75 20.25 0.75Z"
                stroke="#0086F3"
                strokeWidth="1.5"
            />
            <path
                d="M0.75 11.75H24.75L23.75 15.75H1.75L0.75 11.75Z"
                stroke="#0086F3"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
        </svg>
    );
};
